var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[(!_vm.errorMsg)?_c('LoadingSpinner',{staticClass:"mt-12"}):_vm._e(),(_vm.errorMsg)?_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }